const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

export const isFreeModeEnabled = (): boolean => {
  const rawValue = process.env.REACT_APP_FREE_MODE;
  if (!rawValue) return false;
  return TRUE_VALUES.has(rawValue.trim().toLowerCase());
};

export const shouldShowPricing = (): boolean => !isFreeModeEnabled();
